import { storageAvailable, SessionStorage } from "@/cms/components/Common/Utilities/storage/SessionStorage";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
// import { SentryMessage } from "@/shared/sentry/sentry";

const REMIND_ME_URL = process.env.REMIND_ME_URL;

async function fetchAppVersion() {
  try {
    const response = await fetch(`${REMIND_ME_URL}/version.txt`);
    if (response.ok) {
      return await response.text();
    }
    console.error("Failed to fetch app version");
  } catch (error) {
    console.error("Error fetching app version:", error);
  }
  return null;
}

export function useCheckAppVersion() {
  const location = useLocation();

  useEffect(() => {
    async function updateVersion() {
      if (storageAvailable()) {
        const newVersion = await fetchAppVersion();
        const storedVersion = SessionStorage.get("appVersion");

        if (newVersion && newVersion !== storedVersion) {
          // SentryMessage("Page reloaded, because of older app version.");
          SessionStorage.set("appVersion", newVersion);
          window.location.reload();
        }
      }
    }

    updateVersion();
  }, [location.pathname]);
}
